import React, { useState } from 'react';
import { Form, Button, Select, Input } from 'antd';
import { Merchant } from '../../../../models';
import { handleApiExceptions, alertify } from '../../../../app_methods';
import { connect } from 'react-redux';
import { Text4 } from '../../../../styles';
import { getBankLogo } from '../../../../constants';



let CreateAccountForm = (props) => {
    const [isSubmitting, setIsSubmitting] = useState(false);
    const { form, merchant } = props;
    const { getFieldDecorator } = form;

    const onSubmit = (e) => {
        e.preventDefault();
        form.validateFields((err) => {
            if (err) return;
            createAccount(form.getFieldsValue())
        });
    };
    const createAccount = async (values) => {
        setIsSubmitting(true);
        const response = await Merchant.create_account({ ...values });
        if (!response.success) {
            setIsSubmitting(false);
            handleApiExceptions(response);
            return;
        }
        alertify("Success", `Account Created successfully.`, "success");
        setIsSubmitting(false);
        props.toggleCreateAccountModal()
        props.fetchAllotedAccounts();
    };


    return (
        <Form onSubmit={onSubmit}>
            <>
                {getFieldDecorator("merchant_id", {
                    initialValue: merchant.id
                })(<Input autoComplete='off' hidden />)}
                <Form.Item label="Select Bank Account:">
                    {getFieldDecorator("account_id", {
                        rules: [{ required: true, message: "Please select atleast one account." }],
                    })(
                        <Select placeholder={"Select bank account"}>
                            {
                                props.current_user.virtual_accounts.filter(va => va.status == "active" && va.is_connected_banking).map((va, index) => {
                                    return (
                                        <Select.Option value={va.id} disabled={va.funding_via == 2 && !props.current_user.allow_payouts_via_cc_va ? true : false}>
                                            <div className="d-flex">
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        width: 28,
                                                        overflow: "hidden",
                                                        textAlign: "center",
                                                        marginRight: 8
                                                    }}
                                                >
                                                    <img
                                                        style={{
                                                            margin: "auto",
                                                            width: "auto",
                                                            maxWidth: "100%",
                                                            maxHeight: 28
                                                        }}
                                                        alt=""
                                                        src={getBankLogo(va.provider_code)}
                                                    />
                                                </div>
                                                <Text4 className="mr-1">{va.label}</Text4>
                                            </div>
                                        </Select.Option>
                                    )
                                })
                            }
                        </Select>
                    )}
                </Form.Item>
                <Form.Item label={'Add Balance'} >
                    {getFieldDecorator("amount", {
                        rules: [{ pattern: new RegExp(/^\d+(\.\d{1,2})?$/), message: "Please enter a valid amount upto 2 decimal places." }],
                    })(<Input placeholder={"Enter valid amount"}></Input>)}
                </Form.Item>
            </>
            <div className="w-100 d-flex justify-content-end mt-4">
                <Button type="primary" htmlType="submit" loading={isSubmitting}>{"Create"}</Button>
            </div>
        </Form >
    )
};

const mapStateToProps = state => ({
    current_user: state.userReducer.current_user
});

CreateAccountForm = Form.create()(CreateAccountForm);
export default connect(mapStateToProps)(CreateAccountForm);